module.exports = __webpack_public_path__ + "static/media/el_impacto_text.523a2c45.png";